import * as React from "react";
import { DropdownButton, MenuItem } from "components/bootstrap";
const AggregationElementSelect = ({ aggregationElements, onSelect, formValues }) => {
  const menuItems = aggregationElements.filter(({ allowCreate }) => allowCreate(formValues)).map(({ key, title }) => /* @__PURE__ */ React.createElement(MenuItem, { key: `element-select-${key}`, onSelect: () => onSelect(key) }, title));
  return /* @__PURE__ */ React.createElement(DropdownButton, { id: "add-aggregation-element", title: "Add", buttonTitle: "Add an element" }, menuItems);
};
export default AggregationElementSelect;
